import React, { useState, useEffect } from "react";
import { Card, Progress, Typography, Tag, Select, Input, DatePicker, Spin, Modal, notification, Tooltip, Checkbox, Form } from "antd";
import ButtonGlobal from "../../Components/Global/ButtonGlobal";
import moment from "moment";
import ModalDetailArea from "./ModalDetailArea";
import { Element } from "react-scroll";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { LoadingOutlined, VideoCameraFilled, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { EditStatePendingStatesReducer, GetInformationStatusDTReducer, UpdatePendingStatesFieldsReducer, CreatePendingStateReducer, GetDataAreasStatusReducer, DeletePendingStateReducer, editCardReducer } from "../../Redux/Actions/Status/Status";
const loadImage = require.context("../../Assets/Images/Status", true);

const CardDescriptionStatus = (props) => {
  const [showModalDetailArea, setShowModalDetailArea] = useState(false);
  const [nameArea, setNameArea] = useState("");
  const [nameAreaBD, setNameAreaBD] = useState("");
  const [dataModal, setDataModal] = useState([]);
  const [form] = Form.useForm();
  const [editCategoryForm] = Form.useForm();
  const [currentAreaId, setCurrentAreaId] = useState("");
  const [openDeleteStateModal, setOpenDeleteStateModal] = useState({
    active: false,
    stateId: "",
  });

  const [openCreateStateModal, setCreateOpenStateModal] = useState(false);
  const [openEditCategoryModal, setOpenEditCategoryModal] = useState({
    active: false,
    stateId: "",
    card: "",
    category: "",
    subcategory: "",
  });
  const [isCreateStateLoading, setIsCreateStateLoading] = useState(false);
  const [isEditStateLoading, setIsEditStateLoading] = useState(false);
  const [isEditCategoryStateLoading, setIsEditCategoryStateLoading] = useState(false);
  const [isDeleteStateLoading, setIsDeleteStateLoading] = useState({});
  const [editingCell, setEditingCell] = useState({
    owner: "",
    concepto: "",
    entregable: "",
    deadline: "",
  });
  const [loadingFields, setLoadingFields] = useState({
    owner: "",
    concepto: "",
    entregable: "",
    deadline: "",
  });

  const [openConfirmationModal, setOpenConfirmationModal] = useState({
    active: false,
    fieldType: "",
    pendingStateId: "",
    valueToEdit: "",
  });

  const [applyForFollowingMonths, setApplyForFollowingMonths] = useState(false);

  const [updatedOwners, setUpdatedOwners] = useState({});
  const [editOwnerValue, setEditOwnerValue] = useState("");

  const [updatedDeadline, setUpdatedDeadline] = useState({});
  const [editDeadlineValue, setEditDeadlineValue] = useState("");

  const [updatedConcept, setUpdatedConcept] = useState({});
  const [editConceptValue, setEditConceptValue] = useState("");

  const [updatedEntregable, setUpdatedEntregable] = useState({});
  const [editEntregableValue, setEditEntregableValue] = useState("");

  const { arenombre, aremostrar, areporcentajeinicial, areresponsable, areicono, stsstatus, aremodal, aretotal } = props.descriptionStatus;

  const { stsnombre } = stsstatus;

  const { Title } = Typography;
  const dispatch = useDispatch();

  const handleEditCategory = async () => {
    try {
      const values = await editCategoryForm.validateFields();
      const { card, category, subcategory } = values;

      //API call
      const response = await dispatch(editCardReducer(card, category, subcategory, openEditCategoryModal.stateId));
      setIsEditCategoryStateLoading(false);

      if (response.status === 200) {
        notificacionServidor("success", "Tarjeta editada correctamente");
        editCategoryForm.resetFields();
      } else {
        notificacionServidor("error", "No se pudo editar la tarjeta");
      }
    } catch (error) {
      setIsCreateStateLoading(false);
      console.error("Error creating state:", error);
      notificacionServidor("error", "Error en el formulario o al crear el estado");
    }
  };

  const handleCreateState = async () => {
    try {
      //Validar todos los campos del formulario
      const values = await form.validateFields();

      const formattedDate = values.deadline ? values.deadline.format("YYYY-MM-DD") : null;

      //Preparar objeto para enviar a la API
      const newStateData = {
        owner: values.owner,
        concepto: values.concept,
        entregable: values.deliverable,
        deadline: formattedDate,
      };

      //API call
      const response = await dispatch(CreatePendingStateReducer(newStateData, currentAreaId, applyForFollowingMonths));
      setIsCreateStateLoading(false);

      if (response.status === 201) {
        notificacionServidor("success", "Estado creado correctamente");
        form.resetFields();
      } else {
        notificacionServidor("error", "No se pudo crear el estado");
      }
    } catch (error) {
      setIsCreateStateLoading(false);
      console.error("Error creating state:", error);
      notificacionServidor("error", "Error en el formulario o al crear el estado");
    }
  };

  const handleDeleteState = async (stateId) => {
    try {
      //API call
      setIsDeleteStateLoading((prev) => ({ ...prev, [stateId]: true }));
      const response = await dispatch(DeletePendingStateReducer(stateId));
      setIsDeleteStateLoading((prev) => ({ ...prev, [stateId]: false }));

      if (response.status === 200) {
        notificacionServidor("success", "Estado eliminado correctamente");
        form.resetFields();
      } else {
        notificacionServidor("error", "No se pudo eliminar el estado");
      }
    } catch (error) {
      setIsDeleteStateLoading((prev) => ({ ...prev, [stateId]: false }));
      console.error("Error creating state:", error);
      notificacionServidor("error", "Error al eliminar el estado");
    }
  };

  const editStatus = async (fieldType, pendingStateId, valueToEdit) => {
    switch (fieldType) {
      case "owner":
        try {
          setLoadingFields({ ...loadingFields, owner: pendingStateId });
          const updateOwner = await dispatch(UpdatePendingStatesFieldsReducer(pendingStateId, valueToEdit, null, applyForFollowingMonths, null, null));

          if (updateOwner.updatedOwner) {
            setUpdatedOwners((prev) => ({
              ...prev,
              [pendingStateId]: valueToEdit,
            }));
            setEditOwnerValue(updateOwner.updatedOwner);
          }

          setEditingCell({ ...editingCell, owner: false });

          setLoadingFields({ ...loadingFields, owner: "" });

          notificacionServidor("success", "Datos actualizados correctamente");
        } catch (error) {
          setLoadingFields({ ...loadingFields, owner: "" });
          console.error("Failed to update owner:", error);

          notificacionServidor("error", "No se pudo actualizar la información correctamente. Intentelo nuevamente.");
        }
        break;
      case "concepto":
        try {
          setLoadingFields({ ...loadingFields, concepto: pendingStateId });
          const updateConcept = await dispatch(UpdatePendingStatesFieldsReducer(pendingStateId, null, null, applyForFollowingMonths, valueToEdit, null));

          if (updateConcept.updatedConcept) {
            setUpdatedConcept((prev) => ({
              ...prev,
              [pendingStateId]: valueToEdit,
            }));

            setEditConceptValue(updateConcept.updatedConcept);
          }

          setEditingCell({ ...editingCell, concepto: false });

          setLoadingFields({ ...loadingFields, concepto: "" });

          notificacionServidor("success", "Datos actualizados correctamente");
        } catch (error) {
          setLoadingFields({ ...loadingFields, concepto: "" });
          console.error("Failed to update owner:", error);

          notificacionServidor("error", "No se pudo actualizar la información correctamente. Intentelo nuevamente.");
        }
        break;
      case "entregable":
        try {
          setLoadingFields({ ...loadingFields, entregable: pendingStateId });

          const updateEntregable = await dispatch(UpdatePendingStatesFieldsReducer(pendingStateId, null, null, applyForFollowingMonths, null, valueToEdit));

          if (updateEntregable.updatedEntregable) {
            setUpdatedEntregable((prev) => ({
              ...prev,
              [pendingStateId]: valueToEdit,
            }));

            setEditConceptValue(updateEntregable.updatedEntregable);
          }

          setEditingCell({ ...editingCell, entregable: "" });

          setLoadingFields({ ...loadingFields, entregable: "" });

          notificacionServidor("success", "Datos actualizados correctamente");
        } catch (error) {
          setLoadingFields({ ...loadingFields, entregable: "" });
          console.error("Failed to update owner:", error);

          notificacionServidor("error", "No se pudo actualizar la información correctamente. Intentelo nuevamente.");
        }
        break;
      case "deadline":
        // Mismo formato que esp.espfechaprogramado
        const formattedDate = moment(valueToEdit, "DD/MM/YYYY").toISOString();

        //Transformar a formato YYYY-MM-DD para la API
        const formattedDateForAPI = moment(valueToEdit, "DD/MM/YYYY").format("YYYY-MM-DD");

        setEditDeadlineValue(formattedDate);

        try {
          setLoadingFields({ ...loadingFields, deadline: pendingStateId });
          const updateDeadline = await dispatch(UpdatePendingStatesFieldsReducer(pendingStateId, null, formattedDateForAPI, applyForFollowingMonths, null, null));

          if (updateDeadline.updatedDeadline) {
            setUpdatedDeadline((prev) => ({
              ...prev,
              [pendingStateId]: formattedDate,
            }));
          }

          setLoadingFields({ ...loadingFields, deadline: "" });
          await dispatch(GetDataAreasStatusReducer());

          notificacionServidor("success", "Datos actualizados correctamente");
        } catch (error) {
          setLoadingFields({ ...loadingFields, deadline: "" });
          console.log("Error al actualizar la fecha:", error);

          notificacionServidor("error", "No se pudo actualizar la información correctamente. Intentelo nuevamente.");
        }

        setEditingCell({ ...editingCell, deadline: false });
        break;
      default:
        console.error("Invalid field type");
    }
  };

  const formatDateUtc = (date) => {
    const splitDate = date.split("T")[0];
    const formattedDate = new Date(`${splitDate}T00:00:00.000Z`);

    return formattedDate;
  };

  const statusCheck = (deadline, uploadDate, areid) => {
    const todaysDate = new Date();
    const todayUTC = new Date(Date.UTC(todaysDate.getFullYear(), todaysDate.getMonth(), todaysDate.getDate()));
    const formattedDeadline = formatDateUtc(deadline);

    // Compare the dates (both in UTC)
    const isOnTime = formattedDeadline >= todayUTC;

    if (uploadDate) {
      const formattedUploadDate = formatDateUtc(uploadDate);
      const isUploadDateOnTime = formattedUploadDate <= formattedDeadline;

      if (isUploadDateOnTime) {
        return "On Time";
      } else {
        return "Atrasado";
      }
    } else {
      if (isOnTime) {
        return "Proximo a entregar";
      } else {
        return "Atrasado";
      }
    }
  };

  const statusCheckClasses = (deadline, uploadDate) => {
    const todaysDate = new Date();
    const todayUTC = new Date(Date.UTC(todaysDate.getFullYear(), todaysDate.getMonth(), todaysDate.getDate()));
    const formattedDeadline = formatDateUtc(deadline);

    // Compare the dates (both in UTC)
    const isOnTime = formattedDeadline >= todayUTC;

    if (uploadDate) {
      const formattedUploadDate = formatDateUtc(uploadDate);
      const isUploadDateOnTime = formattedUploadDate <= formattedDeadline;

      if (isUploadDateOnTime) {
        return "Green-Status-Table";
      } else {
        return "Red-Status-Table";
      }
    } else {
      if (isOnTime) {
        return "Yellow-Status-Table";
      } else {
        return "Red-Status-Table";
      }
    }
  };

  const notificacionServidor = (type, mensaje) => {
    if (type === "success") {
      notification["success"]({
        message: "Éxito",
        description: mensaje,
      });
    } else if (type === "warning") {
      notification["warning"]({
        message: "Advertencia",
        description: mensaje,
      });
    } else if (type === "error") {
      notification["error"]({
        message: "Error",
        description: mensaje,
      });
    }
  };

  const { rex_data_areas_databases_status, rex_state_estados_pendientes } = useSelector(({ status }) => status);

  const { rex_data_user_logingrow } = useSelector(({ loginGrow }) => loginGrow);

  useEffect(() => {
    if (props.descriptionStatus?.esps?.length) {
      const initialLoadingState = {};
      props.descriptionStatus.esps.forEach((esp) => {
        initialLoadingState[esp.espid] = false;
      });
      setCurrentAreaId(props.descriptionStatus.esps[0].areid);
      setIsDeleteStateLoading(initialLoadingState);
    }
  }, [rex_data_areas_databases_status, props.descriptionStatus?.esps]);

  useEffect(() => {
    if (openEditCategoryModal.active) {
      editCategoryForm.setFieldsValue({
        title: openEditCategoryModal.card,
        category: openEditCategoryModal.category,
        subcategory: openEditCategoryModal.subcategory,
      });
    }
  }, [openEditCategoryModal, editCategoryForm]);

  return !aretotal ? (
    <Element name={areresponsable}>
      {/* Icono y nombre de area */}
      <div className={`${aremostrar ? "" : "Card-Description-Status-Not-Avaliable"}`}>
        <div className="Header-Description-Status">
          <div className="Header-Container-Title-Status">
            <img src={loadImage(`./comercial.png`)} alt={areicono} />
            <Title level={3} className="Title-Description-Status">
              {arenombre}
            </Title>
          </div>
          {/* Boton para agregar estado pendiente */}
          <ButtonGlobal
            nameRoute=""
            txtButton="Nuevo"
            actionButton={() => {
              setCreateOpenStateModal(true);
            }}
          />
          {/* Barra de progreso */}
          <div className="Header-Container-Progress-Status">
            <Progress className="Linear-Description-Status" percent={areporcentajeinicial} strokeColor={areporcentajeinicial <= 70 ? "#FA382D" : areporcentajeinicial <= 95 ? "#FFC700" : "#2AD295"} trailColor="#C4D5FF" />
          </div>
        </div>
        {/* Tarjeta Status */}
        <Card className="Card-Description-Status">
          <table className="Table-Description-Status">
            <thead>
              <tr>
                <th>
                  <small className="Text-Head-Description-Status">Owner</small>
                </th>
                <th>
                  <small className="Text-Head-Description-Status">Usuario</small>
                </th>
                <th>
                  <small className="Text-Head-Description-Status">Concepto</small>
                </th>
                <th>
                  <small className="Text-Head-Description-Status">Entregable</small>
                </th>
                <th>
                  <small className="Text-Head-Description-Status">DeadLine</small>
                </th>
                {/* <th style={{width:'15%'}}>
                                    <small className="Text-Head-Description-Status">DeadLine Actualizado</small>
                                </th> */}
                <th>
                  <small className="Text-Head-Description-Status">Días de Retraso</small>
                </th>
                <th>
                  <small className="Text-Head-Description-Status">Status</small>
                </th>
                <th>
                  <small className="Text-Head-Description-Status">Acciones</small>
                </th>
              </tr>
            </thead>
            <tbody>
              {props.descriptionStatus.esps.map((esp, index_esp) => {
                const regexSPSA = /^SPSA([1-9]|10)$/;
                const regexCencosud = /^CENCOSUD1$/;
                const regexTottus = /^TOTTUS[1-7]$/;

                const isSpsa = regexSPSA.test(esp.field_name_id);
                const isCencosud = regexCencosud.test(esp.field_name_id);
                const isTottus = regexTottus.test(esp.field_name_id);

                return (
                  <tr key={index_esp}>
                    {/* owner */}
                    <td width={150} style={{ textAlign: "center" }}>
                      <Spin spinning={loadingFields.owner === esp.espid} indicator={<LoadingOutlined />} size="small">
                        {editingCell.owner === esp.espid ? (
                          <Input
                            style={{ width: "135px" }}
                            size="small"
                            autoFocus
                            value={editOwnerValue}
                            onChange={(e) => setEditOwnerValue(e.target.value)}
                            onPressEnter={async () => {
                              setOpenConfirmationModal({
                                active: true,
                                fieldType: "owner",
                                pendingStateId: esp.espid,
                                valueToEdit: editOwnerValue,
                              });
                            }}
                          />
                        ) : (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setEditingCell({ ...editingCell, owner: esp.espid });
                              setEditOwnerValue(updatedOwners[esp.espid] || esp.espresponsable || "");
                            }}
                          >
                            {updatedOwners[esp.espid] || esp.espresponsable || ""}
                          </div>
                        )}
                      </Spin>
                    </td>
                    {/* Usuario */}
                    <td width={150}>
                      <Spin spinning={false}>
                        <Tooltip title={esp.perpersonas ? esp.perpersonas.pernombrecompleto : ""} placement="top" color={"geekblue"}>
                          <div
                            style={{
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "100%",
                            }}
                          >
                            {(() => {
                              const text = esp.perpersonas ? esp.perpersonas.pernombrecompleto : "";
                              if (text.length > 15) {
                                return text.substring(0, 15) + "...";
                              }
                              return text;
                            })()}
                          </div>
                        </Tooltip>
                      </Spin>
                    </td>
                    {/* Concepto */}
                    <td width={180}>
                      <Spin spinning={loadingFields.concepto === esp.espid} indicator={<LoadingOutlined />} size="small">
                        {editingCell.concepto === esp.espid ? (
                          <Input
                            style={{ width: "135px" }}
                            size="small"
                            autoFocus
                            value={editConceptValue}
                            onChange={(e) => setEditConceptValue(e.target.value)}
                            onPressEnter={async () => {
                              setOpenConfirmationModal({
                                active: true,
                                fieldType: "concepto",
                                pendingStateId: esp.espid,
                                valueToEdit: editConceptValue,
                              });
                            }}
                          />
                        ) : (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setEditingCell({ ...editingCell, concepto: esp.espid });
                              setEditConceptValue(updatedConcept[esp.espid] || esp.espconcept || "");
                            }}
                          >
                            {updatedConcept[esp.espid] || esp.espconcept || ""}
                          </div>
                        )}
                      </Spin>
                    </td>
                    {/* Entregable  */}
                    <td width={120}>
                      <Spin spinning={loadingFields.entregable === esp.espid} indicator={<LoadingOutlined />} size="small">
                        {editingCell.entregable === esp.espid ? (
                          <Input
                            size="small"
                            autoFocus
                            value={editEntregableValue}
                            onChange={(e) => setEditEntregableValue(e.target.value)}
                            onPressEnter={async () => {
                              setOpenConfirmationModal({
                                active: true,
                                fieldType: "entregable",
                                pendingStateId: esp.espid,
                                valueToEdit: editEntregableValue,
                              });
                            }}
                          />
                        ) : (
                          <Tooltip title={updatedEntregable[esp.espid] || esp.espbasedato || ""} placement="top" color={"geekblue"}>
                            <div
                              style={{
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "100%",
                              }}
                              onClick={() => {
                                setEditingCell({ ...editingCell, entregable: esp.espid });
                                setEditEntregableValue(updatedEntregable[esp.espid] || esp.espbasedato || "");
                              }}
                            >
                              {(() => {
                                const text = updatedEntregable[esp.espid] || esp.espbasedato || "";
                                if (text.length > 15) {
                                  return text.substring(0, 15) + "...";
                                }
                                return text;
                              })()}
                            </div>
                          </Tooltip>
                        )}
                      </Spin>
                    </td>
                    {/* deadline */}
                    <td width={120}>
                      <Spin spinning={loadingFields.deadline === esp.espid} indicator={<LoadingOutlined />} size="small">
                        {editingCell.deadline === esp.espid ? (
                          <DatePicker
                            inputReadOnly={true}
                            placeholder="DD/MM/AAAA"
                            size="small"
                            format="DD/MM/YYYY"
                            value={editDeadlineValue ? dayjs(editDeadlineValue.split("T")[0]) : dayjs(moment().format("DD/MM/YYYY"), "DD/MM/YYYY")}
                            onChange={async (e, date) => {
                              setOpenConfirmationModal({
                                active: true,
                                fieldType: "deadline",
                                pendingStateId: esp.espid,
                                valueToEdit: date,
                              });
                            }}
                          />
                        ) : (
                          <div
                            onClick={() => {
                              setEditingCell({ ...editingCell, deadline: esp.espid });
                              setEditDeadlineValue(updatedDeadline?.[esp.espid] || esp.espfechaprogramado || "");
                            }}
                          >
                            {updatedDeadline?.[esp.espid]
                              ? moment(updatedDeadline[esp.espid]).utc().format("DD/MM/YY")
                              : moment(esp.espfechaprogramado || new Date())
                                  .utc()
                                  .format("DD/MM/YY")}
                          </div>
                        )}
                      </Spin>
                    </td>
                    {/* <td width={120}>{esp.espfechactualizacion ? moment(esp.espfechactualizacion).utc().format('DD/MM/YY') : ''}</td> */}
                    {/* Dias de retraso */}
                    <td width={150}>
                      <Tag className={`Tag-Table-Description-Status ${esp.espdiaretraso == 0 ? "Green-Description-Status" : "Red-Description-Status"}`} style={{ fontSize: "13px" }}>
                        {esp.espdiaretraso} días
                      </Tag>
                    </td>
                    {/* Status */}
                    <td width={100}>
                      <span className={`Text-Status-Table ${statusCheckClasses(esp.espfechaprogramado, esp.espfechactualizacion)}`} style={{ fontSize: "13px" }}>
                        {statusCheck(esp.espfechaprogramado, esp.espfechactualizacion, esp.areid)}
                      </span>
                    </td>
                    {/* Eliminar */}
                    <td width={50}>
                      <Spin spinning={isDeleteStateLoading[esp.espid]} size="small">
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              cursor: isSpsa || isCencosud || isTottus ? "default" : "pointer",
                              color: isSpsa || isCencosud || isTottus ? "#999999" : "inherit",
                            }}
                            onClick={async () => {
                              if (!isSpsa && !isCencosud && !isTottus) {
                                setOpenDeleteStateModal({ active: true, stateId: esp.espid });
                              }
                              // No action if any condition is true
                            }}
                          >
                            <DeleteOutlined />
                          </div>
                          <div
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={async () => {
                              setOpenEditCategoryModal({ active: true, stateId: esp.espid, card: esp.upload_cards?.title || "", category: esp.upload_categories?.name || "", subcategory: esp.upload_subcategories?.name || "" });
                            }}
                          >
                            <EditOutlined />
                          </div>
                        </div>
                      </Spin>
                    </td>
                  </tr>
                );
              })}
              {aremodal ? (
                <tr>
                  <td width={180}>
                    <button
                      className={`Button-Show-More ${aremostrar ? "" : "Card-Description-Status-Not-Avaliable"}`}
                      onClick={async () => {
                        if (aremostrar) {
                          setShowModalDetailArea(true);
                          setNameArea(props.descriptionStatus["esps"][0]["espbasedato"]);
                          setNameAreaBD(arenombre + "-" + stsstatus.stsnombre);
                          let response = await dispatch(GetInformationStatusDTReducer(props.descriptionStatus.areid, props.descriptionStatus));
                        }
                      }}
                    >
                      <span className="Text-Span">Ver detalle</span>
                      <span className="Text-Span-Table-Status">Ver detalle</span>
                      <div className="Circle-Button-Table-Status"></div>
                    </button>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
          <Modal
            open={openConfirmationModal.active}
            title={<span className={`Text-Ok`}>¿Estás seguro de que quieres editar este campo?</span>}
            width={500}
            zIndex={100000000}
            className="Modal-Create-Data-Control"
            footer={[
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <div
                  className={`Button-Close Button-Ok`}
                  onClick={async () => {
                    setOpenConfirmationModal({ active: false, fieldType: "", pendingStateId: "", valueToEdit: "" });
                    await editStatus(openConfirmationModal.fieldType, openConfirmationModal.pendingStateId, openConfirmationModal.valueToEdit);
                  }}
                >
                  Ok
                </div>
                <div
                  className={`Button-Close Button-Alert`}
                  onClick={async () => {
                    setOpenConfirmationModal({ active: false, fieldType: "", pendingStateId: "", valueToEdit: "" });
                  }}
                >
                  No
                </div>
              </div>,
            ]}
          >
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <div className="Modal-Description">{`Estás editando la columna "${openConfirmationModal.fieldType}" con el valor "${openConfirmationModal.valueToEdit}"`}</div>

              <div>
                <Checkbox
                  onChange={(e) => {
                    setApplyForFollowingMonths(e.target.checked);
                  }}
                >
                  <div className="Modal-Description">Aplicar para los siguientes meses</div>
                </Checkbox>
              </div>
            </div>
          </Modal>
          <Modal
            open={openCreateStateModal}
            title={<span className={`Text-Ok`}>Creación de nuevo estado</span>}
            width={500}
            zIndex={100}
            className="Modal-Create-Data-Control"
            footer={[
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <div
                  className={`Button-Close Button-Ok`}
                  onClick={async () => {
                    setIsCreateStateLoading(true);
                    await handleCreateState();
                    setCreateOpenStateModal(false);
                    await dispatch(GetDataAreasStatusReducer());
                  }}
                >
                  Ok
                </div>
                <div
                  className={`Button-Close Button-Alert`}
                  onClick={async () => {
                    setCreateOpenStateModal(false);
                    form.resetFields();
                  }}
                >
                  No
                </div>
              </div>,
            ]}
          >
            <Spin spinning={isCreateStateLoading} size="large">
              <Form form={form} layout="vertical" name="createStateForm" initialValues={{ owner: "", concept: "", deliverable: "", deadline: null }}>
                <Form.Item name="owner" label="Owner" rules={[{ required: true, message: "Por favor ingrese el owner" }]}>
                  <Input placeholder="Ingrese el owner" />
                </Form.Item>

                <Form.Item name="concept" label="Concepto" rules={[{ required: true, message: "Por favor ingrese el concepto" }]}>
                  <Input placeholder="Ingrese el concepto" />
                </Form.Item>

                <Form.Item name="deliverable" label="Entregable" rules={[{ required: true, message: "Por favor ingrese el entregable" }]}>
                  <Input placeholder="Ingrese el entregable" />
                </Form.Item>

                <Form.Item name="deadline" label="Fecha límite" rules={[{ required: true, message: "Por favor seleccione una fecha" }]}>
                  <DatePicker getPopupContainer={(trigger) => trigger.parentElement} zIndex={200} style={{ width: "100%" }} format="DD/MM/YYYY" inputReadOnly={true} placeholder="Seleccione una fecha" />
                </Form.Item>
              </Form>
              <div>
                <Checkbox
                  onChange={(e) => {
                    setApplyForFollowingMonths(e.target.checked);
                  }}
                >
                  <div className="Modal-Description">Aplicar para los siguientes meses</div>
                </Checkbox>
              </div>
            </Spin>
          </Modal>
          <Modal
            open={openDeleteStateModal.active}
            title={<span className={`Text-Ok`}>¿Estás seguro de que quieres eliminar este registro?</span>}
            width={500}
            zIndex={100}
            className="Modal-Create-Data-Control"
            footer={[
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <div
                  className={`Button-Close Button-Ok`}
                  onClick={async () => {
                    const stateId = openDeleteStateModal.stateId;
                    setOpenDeleteStateModal({ active: false, stateId: "" });
                    await handleDeleteState(stateId);
                    await dispatch(GetDataAreasStatusReducer());
                  }}
                >
                  Si
                </div>
                <div
                  className={`Button-Close Button-Alert`}
                  onClick={async () => {
                    setOpenDeleteStateModal({ active: false, stateId: "" });
                  }}
                >
                  No
                </div>
              </div>,
            ]}
          ></Modal>
          <Modal
            open={openEditCategoryModal.active}
            title={<span className={`Text-Ok`}>Editar Categoría</span>}
            width={500}
            zIndex={100}
            className="Modal-Create-Data-Control"
            footer={[
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <div
                  className={`Button-Close Button-Ok`}
                  onClick={async () => {
                    setIsEditCategoryStateLoading(true);
                    await handleEditCategory();
                    setOpenEditCategoryModal({ active: false, stateId: "", card: "", category: "", subcategory: "" });
                    await dispatch(GetDataAreasStatusReducer());
                  }}
                >
                  Save
                </div>
                <div
                  className={`Button-Close Button-Alert`}
                  onClick={async () => {
                    setOpenEditCategoryModal({ active: false, stateId: "", card: "", category: "", subcategory: "" });
                    editCategoryForm.resetFields();
                  }}
                >
                  No
                </div>
              </div>,
            ]}
          >
            <Spin spinning={isEditCategoryStateLoading} size="large">
              <Form form={editCategoryForm} layout="vertical" name="editCategoryForm">
                <Form.Item name="title" label="Nombre de Tarjeta" rules={[{ required: true, message: "Por favor ingrese titulo de la tarjeta" }]}>
                  <Input placeholder="Ingrese el titulo de la tarjeta" />
                </Form.Item>

                <Form.Item name="category" label="Categoría" rules={openEditCategoryModal.category === "" ? [] : [{ required: true, message: "Por favor ingrese el nombre de la categoria" }]}>
                  {openEditCategoryModal.category === "" ? <div style={{ padding: "4px 11px", color: "#999", fontStyle: "italic" }}>Sin categoría</div> : <Input placeholder="Ingrese la categoria" />}
                </Form.Item>

                <Form.Item name="subcategory" label="Subcategoría" rules={openEditCategoryModal.subcategory === "" ? [] : [{ required: true, message: "Por favor ingrese la categoria" }]}>
                  {openEditCategoryModal.subcategory === "" ? <div style={{ padding: "4px 11px", color: "#999", fontStyle: "italic" }}>Sin subcategoría</div> : <Input placeholder="Ingrese la subcategoria" />}
                </Form.Item>
              </Form>
            </Spin>
          </Modal>
        </Card>
      </div>
    </Element>
  ) : null;
};

export default CardDescriptionStatus;
